import $ from "jquery";

const LINK_SELECTOR = "a[data-image-replace]";
const ACTIVE_CLASS = "active";

const markSingleLinkActive = function (element) {
  element.parent().find(LINK_SELECTOR).removeClass(ACTIVE_CLASS);
  element.addClass(ACTIVE_CLASS);
};

const fixLightboxLink = function(element, link) {
  const $parent = element.parent();
  if (!$parent.is("a")) {
    return;
  }
  $parent.attr("href", link);
};

const linkClicked = function (e) {
  e.preventDefault();
  const $this = $(this);
  const $target = $($this.data("image-replace-target"));
  const url = $(this).attr("href");
  $target.attr("src", url);
  markSingleLinkActive($this);
  fixLightboxLink($target, url);
};

$(document).on("turbolinks:load", function () {
  $(LINK_SELECTOR).on("click", linkClicked);
  $("p.screenshot-links a:first-child").addClass(ACTIVE_CLASS);
});
